<template>
  <div id="index">
    <!-- <bread-crumbs :links="breadsCrumbs"></bread-crumbs> -->
    <div class="sticky">
      <v-expand-transition>
        <v-card v-show="openSearchArea" flat>
          <v-container>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field 
                v-model="query_kwd"
                placeholder="食品をキーワードで検索する"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
              prepend-icon="label"
              v-model="query_category"
              :items="configCategory"
              item-text="value" item-value="key" style="padding-top:0;"
              placeholder="食品をカテゴリで絞り込む"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
              prepend-icon="sort"
              v-model="query_sort"
              :items="configSort"
              item-text="value" item-value="key" style="padding-top:0;"
              ></v-select>
            </v-flex>
            <v-layout row wrap>
              <v-flex xs12 id="tagArea">
                <vue-tags-input element-id="tags"
                  v-model="query_tags"
                  placeholder="タグ"
                  :typeahead="true"
                  :existing-tags="configTag"
                ></vue-tags-input>
              </v-flex>
              <v-flex xs12 style="text-align:left;padding:5px 0;overflow-x: auto;white-space:nowrap;">
                <v-chip label dark color="grey darken-2">人気</v-chip>
                <v-chip
                  @click="addTag(tag)"
                  v-for="(tag, id) in displayTag" color="red" outline small :key=id>
                    {{tag.value}}
                </v-chip>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-btn @click="onSearch" color="primary" block large><v-icon>search</v-icon>検索</v-btn>
            </v-flex>
          </v-layout>
          <v-btn v-if="openSearchArea" @click="openSearchArea=!openSearchArea" block flat class="blue-grey lighten-5"><v-icon>close</v-icon>検索エリアを閉じる</v-btn>
          </v-container>
        </v-card>
      </v-expand-transition>
      <v-flex 
         @click="openSearchArea=!openSearchArea"
        xs12 v-if="!openSearchArea" class="primary" style="text-align:right;">
        <v-btn flat color="white" style="font-size:11.5pt;">
          <!-- {{queryForDisplay | textTrim(20)}}<v-icon style="margin-left:10px;">search</v-icon> -->
          <v-icon style="margin-right:5px;">search</v-icon>
          絞込み条件・並び順を変更する<v-icon style="margin-left:5px;">expand_more</v-icon>
        </v-btn>
      </v-flex>
    </div>
    <v-card flat v-if="isNotFound">
      <v-container>
        検索結果が0件です。
      </v-container>
    </v-card>
    <h1 v-if="foods.length>0" 
      style="font-size:16pt;font-weight:bold;text-align:left;padding:10px;background:#fff;">
      {{queryForDisplay | textTrim(20)}}
    </h1>
    <v-card flat>
      <div style="min-height:100px;" :class="{pcView: !isSP}" >
        <food-card 
          @onFoodCardClick="onFoodCardClick"
          :food="food" v-for="(food, id) in foods" :key=id
          style="margin-bottom:3px;border-bottom:solid 1px #ddd;padding:5px 0"
          ></food-card>
      </div>
      <div v-show="isLoading" style="text-align:center;margin:16px;height:200px;">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-card>
    <v-container v-show="!isLoading">
      <v-btn @click="onNext" large block color="primary">もっと見る</v-btn>
    </v-container>
  </div>
</template>

<script>
var queryForDisplayInit = '食品を絞り込む'
import FoodCard from '@/components/card/FoodCard.vue'
import VueTagsInput from '@voerro/vue-tagsinput'
export default {
  name: 'FoodSearch',
  data () {
    return {
      isLoading: false,
      openSearchArea: false,
      foods: [],
      isNotFound:false,
      breadsCrumbs: [{name: 'home', meta: {pageName: 'トップ'}}, {name: 'searchFood', meta: {pageName: '食品検索'}}],
      configSort: [
        {key: 'famous', value: '人気順'},
        {key: 'hot', value: '辛さ順'},
        {key: 'taste', value: '味の評価が高い順'}
      ],
      queryForDisplay: '',
      description: ''
    }
  },
  watch: {
    '$route' (to) {
      if (to.query !== undefined) {
        this.init()
        this.setURL()
      }
    }
  },
  computed: {
    query_kwd: {
      get () {
        return this.$store.state.food.query.kwd
      },
      set (kwd) {
        this.$store.commit('setFoodQueryKwd', kwd)
      }
    },
    query_category: {
      get () {
        return this.$store.state.food.query.category
      },
      set (cat) {
        this.$store.commit('setFoodQueryCategory', cat)
      }
    },
    query_sort: {
      get () {
        return this.$store.state.food.query.sort
      },
      set (v) {
        this.$store.commit('setFoodQuerySort', v)
      }
    },
    query_tags: {
      get () {
        return this.$store.state.food.query.tags
      },
      set (tags) {
        this.$store.commit('setFoodQueryTags', tags)
      }
    },
    configCategory () {
      return this.$store.state.config.category
    },
    configTag () {
      return this.$store.state.config.tag
    },
    displayTag () {
      let tags = []
      this.configTag.forEach(tag => {
        let flag = false
        for (let i = 0; i < this.query_tags.length; i++) {
          if (this.query_tags[i].key === tag.key) {
            flag = true
            break
          }
        }
        if (!flag) {
          tags.push(tag)
        }
      })
      return tags
    },
    displaySize () {
      return this.$vuetify.breakpoint.name
    },
    isSP () {
      if (this.displaySize==='xs' || this.displaySize==='sm') return true
      return false
    }
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // queryを元に検索パラメータを設定
      let query = this.$route.query
      if (query) {
        this.$store.commit('initFood')
        this.foods = []
      }
      if (query.kwd) {
        this.query_kwd = query.kwd
      }
      if (query.category) {
        this.query_category = query.category
      }
      if (query.tag) {
        let tagValues = query.tag.split(',')
        let tags = []
        tagValues.forEach(tv => {
          let t = this.$store.getters.getTagByValue(tv)
          if (t) tags.push(t)
        })
        this.query_tags = tags
      }
      if (query.sort) {
        this.query_sort = query.sort
      }
      // 検索
      this.doSearch()
    },
    async onSearch () {
      this.setURL()
      this.doSearch()
    },
    async doSearch () {
      this.isLoading = true
      this.openSearchArea = false
      window.scrollTo(0, 0)
      this.$store.commit('setFoodQuery')
      this.isNotFound = false
      this.foods = await this.$store.dispatch('getFoodByQuery', true)
      // console.log(this.foods)
      if (this.foods.length === 0) {
        this.isNotFound = true
      }
      this.makeQueryForDisplay()
      this.$emit('updateHead')
      this.isLoading = false
    },
    setURL () {
      let query = {}
      if (this.query_kwd !== '') {
        query.kwd = this.query_kwd
      }
      if (this.query_category !== '') {
        query.category = this.query_category
      }
      if (this.query_tags) {
        let counter = 0
        let t = ''
        this.query_tags.forEach(tag => {
          if (counter === 0) {
            t= t + tag.value
          } else {
            t= t + ',' + tag.value
          }
          counter++
        })
        if (t !== '') {
          query.tag = t
        }
      }
      this.$router.replace({name: 'searchFood', query: query})
    },
    onFoodCardClick (food) {
      this.$router.push({name: 'searchFoodDetail', params: {id: food.id}})
    },
    async onNext () {
      this.isLoading = true
      this.foods = await this.$store.dispatch('getFoodNext')
      this.isLoading = false
    },
    addTag (tag) {
      this.query_tags.push(tag)
    },
    makeQueryForDisplay () {
      let text = ''
      if (this.query_kwd !== '') text = text + this.query_kwd + ' '
      if (this.query_category !== '') {
        let cat = this.$store.getters.getCategoryNameByKey(this.query_category)
        text = text + cat.value + ' '
      }
      if (this.query_tags) {
        this.query_tags.forEach(t => {
          text = text + t.value + ' '
        })
      }
      let sort_txt = ''
      let sort_txt2 = ''
      if (this.query_sort){
        if (this.query_sort === 'famous') {
          sort_txt = '人気順'
          sort_txt2 = '人気ランキング'
        } else if (this.query_sort === 'hot') {
          sort_txt = '辛さ順'
          sort_txt2 = '激辛ランキング'
        } else if (this.query_sort === 'taste') {
          sort_txt = '味の評価順'
          sort_txt2 = '味の評価ランキング'
        } else if (this.query_sort === 'new') {
          sort_txt = '新着順'
          sort_txt2 = '新着順'
        }
      }
      if (text === '') {
        text = sort_txt2
      } else if (this.query_kwd === '' & this.query_tags.length === 0) {
        text = text + 'の' + sort_txt2
      } else {
        text = text + 'の' + sort_txt
      }

      if (text !== '') this.queryForDisplay = text
      else this.queryForDisplay = queryForDisplayInit

      // description
      this.description = this.queryForDisplay + 'はこちら！'
      for (let i = 0; i < this.foods.length; i++) {
        this.description = this.description + this.foods[i].name
        if (this.description.length >= 200) break
      }
    }
  },
  components: {
    FoodCard,
    VueTagsInput
  },
  head: {
    title () {
      if (this.queryForDisplay) {
        return {
          inner: this.queryForDisplay,
          separator: ' ',
          complement: 'カライイネ'
        }
      }
    },
    meta () {
      if (this.description) {
        return [
          {name: 'description', content: this.description}
        ]
      }
    }
  }
}
</script>

<style scoped>
  #index{
    min-height: 90vh;
    text-align:center;
  }
  /* ↓スクロールに応じて要素を固定↓ */
  .sticky {
    position: -webkit-sticky;
    position:sticky;
    top:0;
    z-index: 2;
  }
  .thead-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 3;
  }
  .th-sticky {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 2;
  }
  /* ↑スクロールに応じて要素を固定↑ */
</style>

<style>
.pcView {
  padding: 0 16px;
}
.tags-input {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.tags-input input {
    flex: 1;
    background: transparent;
    border: none;
}

.tags-input input:focus {
    outline: none;
}

.tags-input input[type="text"] {
    color: #495057;
}

.tags-input-wrapper-default {
    padding: 10px;
    background: #fff;
    border: 1px solid transparent;
    border-radius: .25rem;
    border-color: #dbdbdb;
}

/* The tag badges & the remove icon */
.tags-input span {
    margin-right: 0.3rem;
}

.tags-input-remove {
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    overflow: hidden;
}

.tags-input-remove:before, .tags-input-remove:after {
    content: '';
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    background: #5dc282;
    
    height: 2px;
    margin-top: -1px;
}

.tags-input-remove:before {
    transform: rotate(45deg);
}
.tags-input-remove:after {
    transform: rotate(-45deg);
}

/* Tag badge styles */
.tags-input-badge {
    display: inline-block;
    margin-top: 5px;
    padding: 10px;
    font-size: 100%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}

.tags-input-badge-pill {
    padding-right: 0.6em;
    padding-left: 0.6em;
    border-radius: 10rem;
}

.tags-input-badge-selected-default {
    color: #212529;
    background-color: #f0f1f2;
}

/* Typeahead - badges */
.typeahead-badges > span {
    cursor: pointer;
    margin-right: 0.3rem;
}

/* Typeahead - dropdown */
.typeahead-dropdown {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    width: 100%;
    z-index: 1000;
}

.typeahead-dropdown li {
    padding: .25rem 1rem;
    cursor: pointer;
}

/* Typeahead elements style/theme */
.tags-input-typeahead-item-default {
    color: #fff;
    background-color: #343a40;
}

.tags-input-typeahead-item-highlighted-default {
    color: #fff;
    background-color: #f44336;
}
</style>